export default {
  page_name: "Absence Per Subject",
  select_date: "Select Date",
  day: "Day"
};
